module.exports = __webpack_public_path__ + "static/images/red-process.61c3041a7.png";